import { useClientConfigProvider } from "@/app/config/client-config-provider";
import Image from "next/image";
import FallbackImage from "../FallbackImage";
import { useTranslation } from "react-i18next";

export default function SearchItemPopular({
  logo,
  name,
  offerName,
  isAvailableQuota,
  searchOnBehalfOn,
}: {
  logo?: string;
  name?: string;
  offerName?: string;
  isAvailableQuota?: boolean;
  searchOnBehalfOn?: string;
}) {
  const { getImagePath } = useClientConfigProvider();
  const { t } = useTranslation();

  return (
    <div
      className={`search-item-popular ${
        isAvailableQuota == false && searchOnBehalfOn === `BENEFIT`
          ? "search-background-claimed"
          : ""
      }`}
    >
      <FallbackImage
        src={logo ?? ""}
        alt={""}
        width={36}
        height={36}
        className="search-logo-icon"
        fallbackSrc={"/common-images/img_partner_placeholder.jpg"}
      />
      <div className={isAvailableQuota == true ? "w-100" : ""}>
        <div className="font-t-16 font-weight-t-500 search-primary">
          {" "}
          {name ?? ""}{" "}
        </div>

        {searchOnBehalfOn === `BENEFIT` && (
          <div className="font-t-14 font-weight-t-400 search-secondary">
            {offerName ?? ""}
          </div>
        )}
      </div>

      {searchOnBehalfOn === `BENEFIT` && isAvailableQuota == false && (
        <div className="search-claimed-container">
          <div className="search-claimed-style">{t("common.claimed")}</div>
        </div>
      )}

      <>
        {isAvailableQuota === true && searchOnBehalfOn === `BENEFIT` && (
          <Image
            src={getImagePath("arrow-right-black.png")}
            alt="Search Icon"
            width={15.81}
            height={15.81}
          />
        )}

        {searchOnBehalfOn !== `BENEFIT` && (
          <Image
            src={getImagePath("arrow-right-black.png")}
            alt="Search Icon"
            width={15.81}
            height={15.81}
          />
        )}
      </>
    </div>
  );
}
